import { Capacitor, registerPlugin } from '@capacitor/core';
import { isTrustedExternalUrl } from './runtime';

interface ExternalBrowserPlugin {
  open(options: { url: string }): Promise<void>;
}

const ExternalBrowser = registerPlugin<ExternalBrowserPlugin>('ExternalBrowser');

export async function openTrustedExternalUrl(rawUrl: string): Promise<void> {
  if (!isTrustedExternalUrl(rawUrl)) throw new Error('Only trusted HTTPS destinations can be opened.');
  if (Capacitor.isNativePlatform()) {
    await ExternalBrowser.open({ url: rawUrl });
    return;
  }
  window.open(rawUrl, '_blank', 'noopener,noreferrer');
}

